import Utils from '@/helpers/utils'
function listCertificates () {
  return [
    { id: 'VietGAP', name: 'VietGAP' },
    { id: 'LocalGAP', name: 'LocalGAP' },
    { id: 'GlobalGAP', name: 'GlobalGAP' },
    { id: 'Rainforest Alliance', name: 'Rainforest Alliance' },
    { id: 'USDA Organic', name: 'USDA Organic' },
    { id: 'EU Organic', name: 'EU Organic' },
    { id: 'Hữu Cơ Việt Nam', name: 'Hữu Cơ Việt Nam' },
    { id: '4C', name: '4C' },
    { id: 'Fairtrade', name: 'Fairtrade' }
  ]
}
function listProcesses () {
  return [
    {
      id: 'natural',
      name: 'Natural'
    },
    {
      id: 'washed',
      name: 'Washed'
    },
    {
      id: 'wet_hulled',
      name: 'Wet Hulled'
    },
    {
      id: 'honey',
      name: 'Honey'
    }
  ]
}
function listVariants (instance) {
  return new Promise((resolve, reject) => {
    if (typeof (window.CACHE_COFFE_VARIANTS) !== 'undefined') {
      // console.log('get from cache')
      return resolve(window.CACHE_COFFE_VARIANTS)
    }

    Utils.requestV2(instance).get(`/coffee-markets-variants/`).then(response => {
      window.CACHE_COFFE_VARIANTS = response.data

      resolve(response.data)
    }, response => {
      reject(response.status)
    })
  })
}

export default {
  listCertificates,
  listProcesses,
  listVariants
}



// WEBPACK FOOTER //
// ./src/helpers/CoffeeAdHelper.js